import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const isRejected = user?.status === 'rejected';

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-card rounded-lg border border-border p-8 flex flex-col gap-5 text-center">
        <div className="flex flex-col gap-2">
          <div className="text-4xl">{isRejected ? '🚫' : '⏳'}</div>
          <h1 className="text-xl font-bold text-foreground">
            {isRejected ? 'Access Denied' : 'Awaiting Approval'}
          </h1>
        </div>
        {isRejected ? (
          <p className="text-sm text-muted-foreground">
            Your account request has been reviewed and was not approved.
            If you believe this is a mistake, please contact the platform administrator.
          </p>
        ) : (
          <p className="text-sm text-muted-foreground">
            Your account has been created successfully. An administrator will review
            your request and grant access shortly. You will be able to log in once
            your account is approved.
          </p>
        )}
        <p className="text-xs text-muted-foreground">
          Signed in as <span className="text-foreground font-medium">{user?.email}</span>
        </p>
        <button
          onClick={logout}
          className="text-sm text-primary hover:underline"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
